import { Museum, MuseumDetails } from "@Interfaces/dddApi.interfaces";
import { TicketInfo, Validitatemporale } from "@Interfaces/interfaces";
import { TranslateService } from "@ngx-translate/core";
import { ItalianDateService } from "@Services/italian-date.service";
import moment from 'moment';

export const mapValidity = (translate: TranslateService, validity: Validitatemporale) : string =>{

    let unit = "";

    if(validity.quantita !== 1){
        unit = translate.instant(`Validity_unit_plural.${validity.unita}`);
    } else {
        unit = translate.instant(`Validity_unit_singular.${validity.unita}`);
    }

    let validityStr = translate.instant(`Validity_string.${validity.validita}`);

    return `${validity.quantita} ${unit} ${validityStr}`;
}

export const mapMuseumToMuseumDetails = (museum: Museum): MuseumDetails => {
  return {
    id: museum.id, // (codesr)
    id_ticketing: museum.id_ticketing,
    nomzon: museum.denominazione,
    indirizzo: museum.indirizzo,
    cap: museum.cap,
    nome_provincia: museum.nome_provincia,
    sigla_provincia: museum.sigla_provincia,
    nome_comune: museum.nome_comune,
    geometry: museum.geometry,
    denominazione: museum.denominazione,
    immagine_copertina: museum.immagine_copertina,
    immagine_copertina_thumb: museum.immagine_copertina_thumb,
    immagine_alt: museum.immagine_alt,
    orari_apertura: museum.orari_apertura,
    orari_straordinari: museum.orari_straordinari,
    stato_apertura: museum.stato_apertura,
    prossimo_cambio_stato_apertura: museum.prossimo_cambio_stato_apertura,
    reopens_after_temporary_closure: museum.reopens_after_temporary_closure
  };

}

/* istanbul ignore next */
/**
 * Legacy method to check if a pass is expired
 * @param expireDate
 * @deprecated
 * @returns
 */
const passExpired = (expireDate: string) : boolean=>{
    const italianService = new ItalianDateService();
    const today = italianService.getItalianDate();
    const expireDay = new Date(expireDate);
    return today.getTime() > expireDay.getTime();
}

/* istanbul ignore next */
/**
 * Legacy method to check if a ticket is expired counting
 * on both date and time of the ticket
 * @param ticket
 * @deprecated
 * @returns
 */
const  ticketExpired = (ticket: TicketInfo): boolean => {
    const italianService = new ItalianDateService();
    const giornoScadenza = new Date(ticket.validitatemporale.scadenza);
    const today = italianService.getItalianDate();
    if (ticket.fasciaoraria) {
        const fasciaoraria = ticket.fasciaoraria.split('-').at(1)?.split(":");
        if(fasciaoraria){
          giornoScadenza.setHours(Number.parseInt(fasciaoraria?.at(0)!));
          giornoScadenza.setMinutes(Number.parseInt(fasciaoraria?.at(1)!));
        }
    }
    if(giornoScadenza.getTime() < today.getTime()){
        return true;
    }else return false;
}

export const isTicketExpired = (ticket: TicketInfo): boolean => {
    //? Modifica fatta post nuovo handling di data scadenza,
    //? la data scadenza in formato ISO8601  "2025-03-23T23:59:00+01:00"
    //? fa il controllo contro il fuso orario in automatico con moment
    const expirationDate = moment(ticket.validitatemporale.scadenza);
    return moment().isAfter(expirationDate);
}


export const getTicketImg = (ticket: TicketInfo, museum: MuseumDetails): string | null =>{
    let ticketImg : string | null = null;
    if(!ticket.img || ticket.img.length === 0){
        if(museum && museum.immagine_copertina && museum.immagine_copertina.length > 0){
            ticketImg = museum.immagine_copertina;
        }
    }else{
        ticketImg = ticket.img;
    }
    return ticketImg;
}
